export default __webpack_public_path__ + "media/review-save2x.c06d70cc.png";